import { defineStore } from "pinia";

export const useCompetitorProductStore = defineStore('competitorProduct', {
    state: () => ({
        competitorProduct: {},
        competitorProducts: [],
    }),
    actions: {
        setCompetitorProduct(competitorProduct) {
            this.competitorProduct = competitorProduct
        },
        setCompetitorProducts(competitorProducts) {
            this.competitorProducts = competitorProducts
        },
        addCompetitorProduct(competitorProduct) {
            this.competitorProducts.unshift(competitorProduct)
        },
        updateCompetitorProduct(competitorProduct) {
            let index = this.competitorProducts.findIndex(cl => cl.id === competitorProduct.id)
            this.competitorProducts.splice(index, 1, competitorProduct)
        },
        deleteCompetitorProduct(competitorProduct) {
            let index = this.competitorProducts.findIndex(cl => cl.id === competitorProduct.id)
            this.competitorProducts.splice(index, 1)
        },
    },
});